// extracted by mini-css-extract-plugin
export default {"container":"ItemValue_container__SB3nG","color":"ItemValue_color__+XJO3"};